// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"g22Yb","list":"_2DUZ1"};


//////////////////
// WEBPACK FOOTER
// ./components/AutocompleteList/styles.scss
// module id = 606
// module chunks = 0